import { ConferenceListItem } from "@gsx/common/src/types/http/dashboard/conference";

export default (conference: ConferenceListItem) => {
    // @ts-ignore
    const cal = ics(Math.random());
    const location = `${conference.city || ""} ${conference.state || ""}, ${
        conference.country || ""
    }`;

    const details = `https://app.globalspaceexchange.com/dashboard/conferences/${
        conference.conferenceid
    } \\n\\n${conference.url ? conference.url.concat("\\n\\n") : ""}${
        conference.details ? conference.details.replace(/\n/g, "\\n").concat("\\n\\n") : ""
    }${conference.types ? `Types: ${String(conference.types)}\\n\\n` : ""}${
        conference.topics ? `Topics: ${String(conference.topics)}\\n\\n` : ""
    }${
        conference.deadlines && conference.deadlines.length
            ? `Deadlines: \\n${String(
                  conference.deadlines.map(
                      (deadline) => `${deadline.date.toLocaleString()}: ${deadline.title}\\n`,
                  ),
              )}`
            : ""
    }${`\\n${location}`}`;

    cal.addEvent(
        conference.name,
        details,
        location,
        conference.startDate,
        conference.endDate || conference.startDate,
    );
    cal.download(`GSE Event ${conference.name}`);
};
